module.exports = __webpack_public_path__ + "img/Frame5.88b68731.svg";